import { Injectable } from '@angular/core';
import {filter, map, Observable, ReplaySubject} from 'rxjs';
import {I18nKey, LanguageEnum, Translation, translations} from '../models/language.model';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  private readonly translations: Translation;
  private language: LanguageEnum | undefined;
  private _language$ = new ReplaySubject<LanguageEnum>(1);
  public language$: Observable<LanguageEnum> =  this._language$.asObservable();
  
  constructor() {
    this.translations = translations;
  }
  
  public getTranslationByKeyAsync(key: I18nKey, language$ = this._language$.asObservable()): Observable<string> {
    return language$
        .pipe(
            filter(x => !!x),
            map(translations => this.filterOutTranslationByKey(key))
        );
  }
  
  private filterOutTranslationByKey(key: I18nKey): string {
    return !!translations && !!this.language && this.translations[key]?.[this.language] || '';
  }
  
  setLanguage(language: string | undefined) {
    this.language = LanguageEnum.EN;
    if (language !== undefined && language.toUpperCase() in LanguageEnum) {
      this.language = LanguageEnum[language.toUpperCase() as keyof typeof LanguageEnum];
    }
    this._language$.next(this.language);
  }
}
